let currentEquipment = null;

export const equipmentService = {
    setEquipment: (equipment) => {
        currentEquipment = equipment;
    },
    getEquipment: () => currentEquipment
}; 